<template>
  <span>
    <div class="othermediapreview-wrapper" v-if="!isSupportedDocumentType() && !isSupported3dModelType()">
            <div class="othermediapreview-filename">{{nonMediaFileInfo.file_name}}</div>
            <div class="svgicon-download-wrapper">
                <div class="svgicon" v-html="getSvgIcon()">
                </div>
                <div class="download">
                        <div class="couldnotpreviewfile">Couldn't preview file.</div>
                        <button v-if="isPrivilegeEnabled('Download')" @click="downloadFile()" style="font-size:12px;width: 200px;" type="button" class="btn btn-primary"> <span style="position:relative;inset-inline-end :12px;" v-html="getDownloadSvg()"></span> Download</button>
                </div>
            </div>
    </div>
    <div style="width:100%;height:93.5vh" v-if="isSupportedDocumentType()">
          <iframe :src="url" frameborder="0" style="width:100%;height:100%;"></iframe>
    </div>

    <div style="width:100%;height:91.5vh" v-if="isSupported3dModelType()">
         <span v-html="get3dModelHtml()" style="width:100%;height:100%;"></span>
    </div>    
  </span>
</template>

<script>
import Utils from "../../components.utils.js";
import {mapGetters} from "vuex";
import Constants from '../../components.constants.js';
import '@google/model-viewer/dist/model-viewer.js';
export default {
   name:'OtherFilePreview',
   props:['url','asetsInfo'],
   data(){
      return {
          fileUrl:'',
          nonMediaFileInfo:{},
      }
  },
  mounted(){
      this.fileUrl = this.url;
      this.nonMediaFileInfo = this.asetsInfo;
  },
  methods:{
      isPrivilegeEnabled(priv){
        return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege(), priv)
      },
      getSvgIcon(){
          return Utils.determineSvgIconForType(this.nonMediaFileInfo.file_name,'path');
      },

     getDownloadSvg(){
          return Utils.getDownloadSvg();
      },

      downloadFile(){
          this.$emit('triggerfileDownload');
      },
      getDocsPreviewList(){
          return Constants.supportedDocumentPreviewList;
      },
      getMediaType(){
          return Utils.getFileMediaType(this.asetsInfo);
      },
      isSupportedDocumentType(){
          return this.getDocsPreviewList().indexOf(this.getMediaType()) > -1;
      },
      isSupported3dModelType(){
          console.log('Constants.supported3dModelPreviewList',Constants.supported3dModelPreviewList,Constants.supported3dModelPreviewList.indexOf(this.getMediaType()), this.getMediaType());  
          return Constants.supported3dModelPreviewList.indexOf(this.getMediaType()) > -1;
      },
      get3dModelPath(){
           return String(Constants.extendedUrl + '/file/'+ this.asetsInfo._id);
      },
      get3dModelHtml(){
          return `<model-viewer style="width:100%;height:100%;background:#262626;" src=${this.get3dModelPath()}  alt="A 3D model of ${this.asetsInfo.file_name}" shadow-intensity="1" camera-controls="true" auto-rotate="true" ar="true"></model-viewer>`;
      },
      ...mapGetters("users",["getLoggedInUserPrivilege"]),
  }
}
</script>

<style>
   .othermediapreview-wrapper{
       margin-top: 50px;
   }
   .othermediapreview-filename{
        margin-bottom: 39px;
        font-size: 18px;
   }
   .svgicon-download-wrapper .svgicon{
        width: 200px;
        height: 200px;
        text-align: center;
        margin: 0 auto;
   }
   .download{
     margin-top: 25px;
     width: 100%;
   }
   .couldnotpreviewfile{
        font-size: 15px;
        margin-bottom: 20px;
        color: #7b7b7b;
   }
</style>